import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const LabelStyle = ({ bgColor }) => ({
  padding: '4px 12px',
  borderRadius: '16px',
  border: 'none',
  backgroundColor: bgColor,
  width: 'fit-content'
});

export const LabelStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'bgColor'
})(LabelStyle);
